<template>
  <div class="category-section">
    <div class="section-title">
      <div class="divider"></div>
    </div>
    <div class="categories-container">
      <div
          class="category-card"
          v-for="category in categories"
          :key="category.id"
          @click="handleCategoryClick(category.id)"
      >
        <div class="category-image">
          <!-- 分类名称已通过父组件的 i18n 处理，直接使用即可 -->
          <img :src="category.image" :alt="category.name" />
        </div>
        <div class="category-name">
          <span>{{ category.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategorySection',
  props: {
    // 标题和副标题由父组件通过 $t() 传递国际化文本
    title: {
      type: String,
      default: "SHOW BY CATEGORY" // 默认值作为 fallback
    },
    subtitle: {
      type: String,
      default: "ALL CATEGORIES" // 默认值作为 fallback
    },
    // 分类数组中的 name 已由父组件通过 i18n 处理
    categories: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleCategoryClick(categoryId) {
      this.$emit('category-clicked', categoryId);
    }
  }
};
</script>

<style scoped>
/* 原有样式保持不变 */
.category-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 50px 0;
}

.section-title {
  text-align: center;
  margin-bottom: 30px;
}

.section-title h1 {
  font-size: 24px;
  margin-bottom: 10px;
}

.section-title h3 {
  font-size: 16px;
  color: #666;
}

.divider {
  width: 80%;
  max-width: 1000px;
  height: 2px;
  background-color: #333;
  margin: 20px auto;
}

@media (min-width: 768px) {
  .categories-container {
    width: 80%;
    max-width: 1500px;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    gap: 20px;
  }

  .category-card {
    background-color: #f8f8f8;
    border-radius: 10px;
    overflow: hidden;
    transition: all 0.3s ease;
    cursor: pointer;
  }

  .category-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 12px #409eff;
    border: 1px solid #ddd;
  }

  .category-image {
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
  }

  .category-image img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .category-name {
    padding: 10px;
  }

  .category-name span {
    font-size: 16px;
  }
}

@media (max-width: 767px) {
  .category-section {
    margin: 25px 0;
  }

  .section-title {
    margin-bottom: 15px;
  }

  .section-title h1 {
    font-size: 20px;
    margin-bottom: 8px;
  }

  .section-title h3 {
    font-size: 15px;
  }

  .divider {
    width: 50%;
    height: 1.5px;
    margin: 12px auto;
  }

  .categories-container {
    width: 95%;
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 12px;
  }

  .category-card {
    background-color: #f8f8f8;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.2s ease;
    cursor: pointer;
    min-height: 130px;
    border: 1px solid #eee;
  }

  .category-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
  }

  .category-card:active {
    transform: scale(0.98);
    background-color: #f0f0f0;
  }

  .category-image {
    height: 85px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
  }

  .category-image img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .category-name {
    padding: 8px;
    text-align: center;
  }

  .category-name span {
    font-size: 14px;
    color: #333;
  }
}
</style>
